// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pd-1";
export var stateContainer = "_pd-0";